import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/signature_02_m_new.svg")